const cadastro_de_ensino_sem_retencao = {
  path: "/cadastro-de-ensino-sem-retencao",
  redirect: "/cadastro-de-ensino-sem-retencao",
  meta: {
    breadCrumb: "Planejamento Matricula - Tabelas de Apoio ao Planejamento",
  },
  children: [
    {
      path: "/cadastro-de-ensino-sem-retencao",
      name: "cadastro-de-ensino-sem-retencao",
      meta: {
        allowedPermissions: [
          "valor_absoluto_listar",
          "valor_absoluto_buscar",
          "valor_absoluto_excluir",
        ],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroDeEnsinoSemRetencao/CadastroDeEnsinoSemRetencaoHome.vue"
        ),
    },
    {
      path: "/cadastro-de-ensino-sem-retencao-novo",
      name: "cadastro-de-ensino-sem-retencao-novo",
      meta: {
        allowedPermissions: [
          "valor_absoluto_listar",
          "valor_absoluto_buscar",
          "valor_absoluto_excluir",
        ],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroDeEnsinoSemRetencao/CadastroDeEnsinoSemRetencaoCreate.vue"
        ),
    },
    {
      path: "/cadastro-de-ensino-sem-retencao-editar/:id",
      name: "cadastro-de-ensino-sem-retencao-editar",
      meta: {
        allowedPermissions: [
          "valor_absoluto_listar",
          "valor_absoluto_buscar",
          "valor_absoluto_excluir",
        ],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/CadastroDeEnsinoSemRetencao/CadastroDeEnsinoSemRetencaoUpdate.vue"
        ),
    },
  ],
};

export { cadastro_de_ensino_sem_retencao };
